module.exports = __webpack_public_path__ + "img/_LemonBlue.f044d22c.png";